
const initialState = {
    DayShiftCounter: {},
    ShiftList: [],
    TerminalList: [],
    SelectedOrder: {},
    TerminalOrderModeList: [],
};

const POSReducer = (state = initialState, action) => {
    switch (action.type) {
        case "POS_DAY_SHIFT_TERMINAL":
            return { ...state, DayShiftCounter: action.payload };
        case "POS_SHIFT_LIST":
            return { ...state, ShiftList: action.payload };
        case "POS_TERMINAL_LIST":
            return { ...state, TerminalList: action.payload };
        case "POS_SELECTED_ORDER":
            return { ...state, SelectedOrder: action.payload };
        case "POS_TERMINAL_ORDERMODE":
            return { ...state, TerminalOrderModeList: action.payload };
        default: {
            return state;
        }
    }
};

export default POSReducer;